/**
 * @author: lv.chen
 * @date: 2025/4/27
 * @desc: 可删除的标签列表
 */
import React, { useRef } from 'react';
import classnames from 'classnames';
import ListRenderGuide from '@gp/components/ListRenderGuide';
import GeneralDeletableTag from '@gp/components/GeneralDeletableTag';
import useFlexSpacingLayoutInfo, {
  IFlexItemLayoutSpacingOptions,
  FLEX_ITEM_HORIZONTAL_SPACING,
  FLEX_ITEM_VERTICAL_SPACING,
} from '@gp/hooks/useFlexSpacingLayoutInfo';

import type { IBaseProps } from '@home/types/common';
import type { IGeneralTagFormatter } from '@gp/components/GeneralTag';

import './index.scss';

interface IGeneralDeletableTagListProps extends IBaseProps {
  tagsSpacingOptions?: IFlexItemLayoutSpacingOptions;
  tags?: string[] | null;
  formatter?: IGeneralTagFormatter;
  onDelete?: (text?: string) => void;
}

const DEFAULT_TAGS_SPACING_OPTIONS: IFlexItemLayoutSpacingOptions = {
  horizontalSpacing: 6,
  verticalSpacing: 6,
};

const GeneralDeletableTagList: React.FC<IGeneralDeletableTagListProps> = (props) => {
  const { style, className, tagsSpacingOptions = DEFAULT_TAGS_SPACING_OPTIONS, tags, formatter, onDelete } = props;

  const root = useRef<HTMLUListElement | null>(null);

  const flexItemsLayoutInfos = useFlexSpacingLayoutInfo(root, tags as any, tagsSpacingOptions);

  return (
    <ListRenderGuide list={tags}>
      <ul ref={root} style={style} className={classnames('dbg-general-deletable-tag-list', className)}>
        {tags?.map((tag, tagIndex) => {
          const { marginRight = FLEX_ITEM_HORIZONTAL_SPACING, marginBottom = FLEX_ITEM_VERTICAL_SPACING } =
            flexItemsLayoutInfos[tagIndex] || {};
          return (
            <li key={tag} style={{ marginRight, marginBottom }} className="dbg-general-deletable-tag-item">
              <GeneralDeletableTag text={tag} formatter={formatter} onDelete={onDelete} />
            </li>
          );
        })}
      </ul>
    </ListRenderGuide>
  );
};

export default GeneralDeletableTagList;
